import axios from "axios"; //instancia unica de axios
const API_URL = process.env.REACT_APP_SERVER;

export const _axios = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Esta línea asegura que las cookies se incluyan en las solicitudes
  // headers: {
  //   "Cache-Control": "no-cache",
  //   "Content-Type": "application/x-www-form-urlencoded",
  // },
});

// Añadir un interceptor para incluir el token en los headers
_axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  // Manejar errores
  return Promise.reject(error);
});